<template>
  <div class="category-tabs">
    <button class="nav-btn" @click="prevSlide">
      <ChevronLeftIcon class="nav-btn" />
    </button>

    <div class="tabs-scroll">
      <div
        class="carousel-track"
        :style="{
          transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
        }"
      >
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab-item"
          :class="{ active: activeTab === tab.label }"
          @click="setActive(tab.label)"
        >
          <span class="tab-icon">{{ tab.icon }}</span>
          <span
            class="tab-label"
            :class="{ active: activeTab === tab.label }"
            >{{ tab.label }}</span
          >
        </div>
      </div>
    </div>

    <button class="nav-btn" @click="nextSlide">
      <ChevronLeftIcon style="transform: rotate(180deg)" />
    </button>

    <div class="select-provider">
      <button class="provider-btn">
        📌 <span>Select provider</span>
        <ChevronLeftIcon style="transform: rotate(180deg)" class="tab-arrow" />
      </button>
    </div>
  </div>
</template>

<script>
import ChevronLeftIcon from "../icons/ChevronLeftIcon.vue";

export default {
  name: "CategoryTabs",
  components: { ChevronLeftIcon },
  data() {
    return {
      activeTab: "Lobby",
      tabs: [
        { icon: "🎲", label: "Lobby" },
        { icon: "🔥", label: "Hot" },
        { icon: "⭐", label: "New" },
        { icon: "🎰", label: "Slots" },
        { icon: "⚡", label: "Crash" },
        { icon: "🎯", label: "Live" },
        { icon: "💎", label: "Jackpot Games" },
        { icon: "🀄", label: "Table Games" },
        { icon: "🀄", label: "Card Games" },
      ],

      currentIndex: 0,
      visibleSlides: 8,
    };
  },
  mounted() {
    this.updateVisibleSlides();
    window.addEventListener('resize', this.updateVisibleSlides);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateVisibleSlides);
  },
  methods: {
    setActive(label) {
      this.activeTab = label;
    },
    nextSlide() {
      if (this.currentIndex < this.tabs.length - this.visibleSlides) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    updateVisibleSlides() {
      const w = window.innerWidth;
      if (w < 480) this.visibleSlides = 2;
      else if (w < 768) this.visibleSlides = 3;
      else if (w < 1024) this.visibleSlides = 5;
      else this.visibleSlides = 8;
    }
  },
};
</script>

<style scoped>
.category-tabs {
  display: flex;
  align-items: center;
  background-color: rgb(31 31 36);
  padding: 12px 16px;
  border-radius: 16px;
  overflow-x: auto;
  gap: 12px;
  width: 100%;
}

.arrow-btn {
  background: none;
  color: #888;
  font-size: 24px;
  cursor: pointer;
  border: none;
}

.tabs-scroll {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-track {
  display: flex;
  transition: transform 0.6s ease;
  width: 100%;
}

.tab-item {
  flex: 0 0 calc(100% / 8 - 12px);
  margin: 0 0.6px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.75rem;
  border-radius: 12px;
  font-weight: 500;
  color: #ccc;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}

@media only screen and (max-width: 1024px) {
  .tab-item { flex: 0 0 calc(100% / 5 - 12px); }
}
@media only screen and (max-width: 768px) {
  .tab-item { flex: 0 0 calc(100% / 3 - 12px); }
}
@media only screen and (max-width: 480px) {
  .tab-item { flex: 0 0 calc(100% / 2 - 12px); }
}

.tab-item.active {
  background-color: rgb(15 80 70);
  color: #fff;
}

.tab-icon {
  font-size: 18px;
}

.tab-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: rgb(121 121 134);
}
.tab-label.active {
  color: #fff;
}

.tab-label:hover {
  color: #fff;
}

.tab-arrow {
  font-size: 12px;
  color: #999;
}

.select-provider {
  flex-shrink: 0;
}

.provider-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgb(41 41 46);
  border: 2px solid rgb(44 44 49);
  font-size: 0.8125rem;
  color: white;
  font-weight: 600;
  padding: 0.75rem;
  border-radius: 12px;
  border: none;
  cursor: pointer;
}

.nav-btn {
  color: #fff;
  cursor: pointer;
}
</style>
